<template>
  <div class="test-free">
    <div class="free-text">
      <div class="free-left">
        <i></i>
        <h3>免费试题</h3>
      </div>
      <!-- <a href="javascript:;">
        <p>查看更多</p>
        <el-icon><ArrowRight /></el-icon>
      </a> -->
    </div>
    <div class="free">
      <Transition name="fade">
        <div v-if="sliders.length" class="free-box">
          <ul>
            <li v-for="item in sliders" :key="item.index">
              <span>
                <h3>{{ item.bannerName }}</h3>
                <p>
                  {{ item.bannerDesc }}
                </p>
              </span>
              <img v-lazy="item.bannerImg" alt="2025年山河医学网免费试题" />
            </li>
          </ul>
        </div>
        <TestFreeSkeleton v-else />
      </Transition>
    </div>
  </div>
</template>

<script>
import TestFreeSkeleton from "./test-free-skeleton.vue";
import { findBanner } from "@/api/home";
import { ref } from "vue";
export default {
  name: "TestFree",
  components: {
    TestFreeSkeleton,
  },
  setup() {
    const sliders = ref([]);
    findBanner(1719568152458)
      .then((data) => {
        sliders.value = data;
      })
      .catch((error) => {
        console.log(error);
      });
    return { sliders };
  },
};
</script>

<style lang="less" scoped>
.test-free {
  .free-text {
    display: flex;
    justify-content: space-between;
    width: 1240px;
    margin: 0 auto;
    .free-left {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        height: 20px;
        width: 3px;
        background: @shColor;
      }
      h3 {
        height: 50px;
        margin-left: 15px;
        line-height: 50px;
      }
    }
    a {
      display: flex;
      align-items: center;
      margin-right: 8px;
      &:hover {
        color: @shColor;
      }
    }
  }
  .free {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1240px;
    margin: 0 auto;
    height: 500px;
    background: #fff;
    border-radius: 8px;
    .free-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      width: 1220px;
      height: 480px;
      ul {
        display: contents;
        li {
          display: flex;
          align-items: center;
          width: 400px;
          height: 150px;
          border-radius: 8px;
          background: rgb(245, 245, 245);
          span {
            display: block;
            margin-left: 8px;
            margin-right: 8px;
            width: 250px;
            p {
              padding-top: 8px;
            }
          }
          img {
            width: 130px;
            height: 130px;
          }
        }
      }
    }
  }
}
</style>
